// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"25":"03b6159bf7a8d49b","4228":"057ed29165f6b05b"}[chunkId] + ".css";
};